import { render, staticRenderFns } from "./CreateSlotItem.vue?vue&type=template&id=57e8b546&scoped=true&"
import script from "./CreateSlotItem.vue?vue&type=script&lang=js&"
export * from "./CreateSlotItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8b546",
  null
  
)

export default component.exports